import { Command } from "@vendor/cmdk/cmdk";
import { useCanShowDemoFeatureFlags } from "@components/featureFlags/featureFlagsPanel";
import { useIsKickStaff } from "@components/demo/busyClosesDemo/useBusyClosesDemoGate";
import { BusyClosesDemoCommand } from "./BusyClosesDemoCommand";
import { FeatureFlagsCommand } from "./FeatureFlagsCommand";

/** The palette's Staff group; each item keeps its own gate, and the group hides when neither shows. */
export const StaffCommands = () => {
    const canShowFeatureFlags = useCanShowDemoFeatureFlags();
    const canToggleBusyClosesDemo = useIsKickStaff();

    if (!canShowFeatureFlags && !canToggleBusyClosesDemo) {
        return null;
    }

    return (
        <Command.Group heading="Staff">
            <FeatureFlagsCommand />
            <BusyClosesDemoCommand />
        </Command.Group>
    );
};
